import { Component, Input } from '@angular/core';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';

@Component({
    selector: 'file-select',
    templateUrl: './file-select.component.html',
    styleUrls: ['./file-select.component.scss']
})
export class FileSelectComponent extends FileUploadComponent {

    @Input()
    public favicon?: string;

    constructor() {
        super();
    }
}
